import { Component } from '@angular/core';
import { StandardDTO } from '../../model/standard.entity';
import { AdminService } from '../../services/admin.service';
import { CommonService } from '../../../core/common/services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { Dropdown } from 'primeng/dropdown';
import { Utility } from '../../../core/common/services/utility.service';


@Component({
  selector: 'tandc-save-standard',
  templateUrl: './save-standard.component.html',
  styleUrls: ['./save-standard.component.scss']
})
export class SaveStandardComponent {
  performanceCriteria:any;
  model: StandardDTO = new StandardDTO();
  modalTitle: string = "";
  performanceCriteriaList: Dropdown[] = [];

  constructor(private service: AdminService,
    private commonService: CommonService,
    private utility: Utility,
    private translate: TranslateService,
    private route: ActivatedRoute) { }
  
  ngOnInit(): void {
    const copiedData = history.state?.copiedData;
    if (copiedData) {
      this.model = { ...copiedData, id: 0 };
      this.model.performanceCriteria = (copiedData.performanceCriteria || copiedData.PerformanceCriteria || []).map(id => Number(id));
      this.modalTitle = this.translate.instant('common.copy') + ' ' + this.translate.instant('Master.standard');
    }
    else {
      const id = this.route.snapshot.paramMap.get('id');
      if (id && Number(id) > 0) {
        this.modalTitle = this.translate.instant('common.update') + ' ' + this.translate.instant('Master.standard');
        this.service.getStandardById(Number(id)).subscribe((x) => {
          this.model = x.value;
          this.model.performanceCriteria = this.model.performanceCriteria?.map(id => Number(id)) || [];
        });
      } else {
        this.modalTitle = this.translate.instant('common.add') + ' ' + this.translate.instant('Master.standard');
        this.model.performanceCriteria = [];
      }
    }
    this.getPerformanceCriteria();
  }




  save(data: StandardDTO) {
    if (data.id > 0) {
      this.service.updateStandard(data).subscribe((res) => {
        if (res) {
          this.commonService.successMessage(
            this.translate.instant('Alerts.UpdatedSuccessfully')
          );
        }
      });
    } else {
      this.service.saveStandard(data).subscribe((res) => {
        if (res) {
          this.commonService.successMessage(
            this.translate.instant('Alerts.SavedSuccessfully')
          );
        }
      });
    }
  }

  getPerformanceCriteria() {
  this.service.getPerformanceCriteria().subscribe(x => {
    this.performanceCriteriaList = x.value;

    // Ensure only valid IDs exist in model
    this.model.performanceCriteria = (this.model.performanceCriteria || []).filter(id =>
      this.performanceCriteriaList.some(option => option.id === id)
    );

    // Optional: reorder selected on top
    this.performanceCriteriaList = Utility.reorderSelectedOnTop(
      this.performanceCriteriaList,
      this.model.performanceCriteria
    );
  });
}



  selectedStandards(value: any) {
    let std = this.performanceCriteriaList.find(item => item.id == value);
    return std?.name;

  }

  delete(standard: any, model: any) {
    const index = model.standard.indexOf(standard);
    this.model.performanceCriteria = this.model.performanceCriteria.filter(x => x != standard);
  }

}
